<accredible-base-footer *transloco="let t; lang: 'en|static' read: 'badgedirectory_intact_ca.footer'">
  <div class="content">
    <div class="logo-and-language-selector">
      <img
        [alt]="t('intact_logo')"
        class="branding-logo"
        src="/assets/themes/badgedirectory.intact.ca/images/header_logo.png">
    </div>
 
    <div class="links">
      <nav [attr.aria-label]="t('aria_footer_links')"
        class="footer-links-nav"
        role="navigation">
        <ul>
          <li>
            <a href="{{ t('submit_general_application.url') }}"
              target="_blank">
              {{ t('submit_general_application.label') }}
            </a>
          </li>
        </ul>
      </nav>

      <div class="copyrights">{{ t('copyrights', { currentYear: currentYear }) }}</div>
    </div>
  </div>
</accredible-base-footer>
